import React, { useState } from 'react';
import ListFinanceInstitutions from './ListFinanceInstitutions.js';
import AddFinanceInstitution from './AddFinanceInstitution.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const FinanceInstitutions = ({ screen, setScreen, hideHeader }) => {
  const [localScreen, setLocalScreen] = useState('list');
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {!hideHeader && (
        <div className="content-header">
          <div className="action-buttons">
            <ListButton isActive={currentScreen === 'list'} onClick={() => setCurrentScreen('list')} />
            <AddButton isActive={currentScreen === 'add'} onClick={() => setCurrentScreen('add')} />
          </div>
        </div>
      )}
      {currentScreen === 'list' && <ListFinanceInstitutions />}
      {currentScreen === 'list' && <FAB onClick={() => setCurrentScreen('add')} />}
      {currentScreen === 'add' && (
        <AddFinanceInstitution onSuccess={() => setCurrentScreen('list')} />
      )}
    </>
  );
};

export const FinanceInstitutionsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton isActive={screen === 'list'} onClick={() => setScreen('list')} />
    <AddButton isActive={screen === 'add'} onClick={() => setScreen('add')} />
  </div>
);

export default FinanceInstitutions;
